import React from 'react'
import CreateJourneyFromTravelComponentsDayCard
    from "../create-journey-from-travel-components-day-card/CreateJourneyFromTravelComponentsDayCard";
import './styles.css'
import AllActivitiesCard from '../all-activities-card/AllActivitiesCard'
import {JourneyDnDCommonProps} from "../../common";
import {createArrayFromNumber} from "../../../../utils/common";
import {AllActivityTypesArray} from "../../../../types-enums/activity";

export const ALL_ACTIVITIES = "allActivities"

interface CreateJourneyFromTravelComponentsProps extends JourneyDnDCommonProps {
    originalActivities: AllActivityTypesArray
}

const CreateJourneyFromTravelComponents = ({
                                               isRecalculatingActivityEmissions,
                                               journeyDurationInDays,
                                               onDeleteActivity,
                                               onActivityArrow,
                                               isOverAllActivitiesDroppableZone,
                                               draggingActivity,
                                               hasExactDates,
                                               activities,
                                               originalActivities
                                           }: CreateJourneyFromTravelComponentsProps) => <div
    className={'create-journey-from-travel-components-container'}>
    <AllActivitiesCard
        journeyDurationInDays={journeyDurationInDays!!}
        onDelete={activity => onDeleteActivity && onDeleteActivity(activity, ALL_ACTIVITIES)}
        isOver={Boolean(isOverAllActivitiesDroppableZone)}
        onArrowDown={activity => onActivityArrow(ALL_ACTIVITIES, 'down', activity)}
        hasExactDates={hasExactDates}
        activities={originalActivities}
        isRecalculatingActivityEmissions={isRecalculatingActivityEmissions}
        droppableZoneId={ALL_ACTIVITIES}/>
    {createArrayFromNumber(journeyDurationInDays!!).map((day, index) => {
            const activitiesAtDay = activities.filter(activity => activity.common.day === day)
            const droppableZoneId = day.toString()
            return <CreateJourneyFromTravelComponentsDayCard
                hasExactDates={hasExactDates}
                draggingActivity={draggingActivity}
                journeyDurationInDays={journeyDurationInDays}
                onActivityDelete={activity => onDeleteActivity && onDeleteActivity(activity, droppableZoneId)}
                onActivityArrowUp={activity => onActivityArrow(droppableZoneId, 'up', activity)}
                onActivityArrowDown={activity => onActivityArrow(droppableZoneId, 'down', activity)}
                allActivities={activitiesAtDay}
                isRecalculatingActivityEmissions={isRecalculatingActivityEmissions}
                key={index}
                day={day}
                droppableZoneId={droppableZoneId}/>
        }
    )}
</div>

export default CreateJourneyFromTravelComponents